import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Feature } from 'geojson'

interface MapState {
  hoveredId: string | null
  selectedId: string | null
  popupData: Feature | null
}

const initialState: MapState = {
  hoveredId: null,
  selectedId: null,
  popupData: null,
}

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMapHoveredId: (state, action: PayloadAction<string>) => {
      state.hoveredId = action.payload
    },
    resetMapHoveredId: state => {
      state.hoveredId = null
    },
    setMapSelectedId: (state, action: PayloadAction<string>) => {
      state.selectedId = action.payload
    },
    resetMapSelectedId: state => {
      state.selectedId = null
    },
    setMapPopupData: (state, action: PayloadAction<Feature>) => {
      state.popupData = action.payload
    },
    resetMapPopupData: state => {
      state.popupData = null
    },
    toggleMapPopupData: (state, action: PayloadAction<Feature>) => {
      if (state.popupData?.properties?.id === action.payload.properties?.id) {
        state.popupData = null
      } else {
        state.popupData = action.payload
      }
    },
  },
})

export const {
  setMapHoveredId,
  resetMapHoveredId,
  setMapSelectedId,
  resetMapSelectedId,
  setMapPopupData,
  resetMapPopupData,
  toggleMapPopupData,
} = mapSlice.actions

export default mapSlice.reducer
